import { Form, FormInstance, Input, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import { useGetSystemBank, useGetUserBank } from "../../../../api/bank";
import { useGetDetailBankAcccount } from "../../../../api/bankAccount";
import Arrowdown from "../../../../common/images/png/ArrowDown.png";
import { ReactComponent as CheckSelectIcon } from "../../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as PlusGradientIcon } from "../../../../common/images/svg/PlusGradient.svg";
import { ReactComponent as ArrowIcon } from "../../../../common/images/svg/SuffixSelectIcon.svg";
import { ReactComponent as ClearIcon } from "../../../../common/images/svg/XCircle.svg";
import { CustomButton } from "../../../../components/button/buttonCustom";
import { ButtonOutlinedCustom } from "../../../../components/button/buttonOulined";
import {
  accountNumberRules,
  branchNumberRules,
  clearFieldErrorMessageOnChange,
  onlyLatinCharsDigitsRule,
} from "../../../../utils/form.constants";
import { useMetadataCountries } from "../../../../utils/hooks/useMetadataCountries";
import { useMetadataCurrency } from "../../../../utils/hooks/useMetadataCurrency";
import useResponsive from "../../../../utils/hooks/useResponsive";
import FormBankAddNew from "../../management/modal-add-new/new-payee/form-bank-add-new";

const { Option, OptGroup } = Select;

interface IFormBankProps {
  form: FormInstance<any>;
  bankAccountId: number | null;
  handleCancel: () => void;
  onSubmitBankAccount: (values: any) => void;
  isLoading: boolean;
  actionBankAccount: "ADD" | "EDIT" | null;
}

const start = 0;
const end = 10;
const requiredFields = [
  "bankId",
  "accountNumber",
  "currencyCode",
  "branchNumber",
];

const requiredFieldsAddNew = [
  "accountNumber",
  "currencyCode",
  "branchNumber",
  "bankName",
  "bankSwift",
  "bankAddress",
  "bankCountry",
];

const FormBank = ({
  form,
  bankAccountId,
  handleCancel,
  onSubmitBankAccount,
  isLoading,
  actionBankAccount,
}: IFormBankProps) => {
  const [searchCurrency, setSearchCurrency] = useState<string>("");
  const { isTablet } = useResponsive();

  const { data: detailBankAccount } = useGetDetailBankAcccount(
    bankAccountId || 0
  );

  const { metadataCurrency } = useMetadataCurrency();
  const { metadataCountries } = useMetadataCountries();

  const [addNewBank, setAddNewBank] = useState(false);
  const [params, setParams] = useState({ start, end });
  const [paramSystem, setParamSystem] = useState({ start, end });
  const [searchBank, setSearchBank] = useState();
  const [bankSelected, setBankSelected] = useState<any>();
  const [isAllFieldsFilled, setIsAllFieldsFilled] = useState(true);
  const [option, setOption] = useState<any>(null);

  // const bankId = Form.useWatch("bankId", form);
  // const accountNumber = Form.useWatch("accountNumber", form);
  // const currencyCode = Form.useWatch("currencyCode", form);
  // const abaRoutingNumber = Form.useWatch("abaRoutingNumber", form);
  // const bankStateBranchNumber = Form.useWatch("bankStateBranchNumber", form);
  // const branchNumber = Form.useWatch("branchNumber", form);
  // const bankName = Form.useWatch("bankName", form);
  // const bankSwift = Form.useWatch("bankSwift", form);
  // const bankAddress = Form.useWatch("bankAddress", form);
  // const bankCountry = Form.useWatch("bankCountry", form);

  const { data: metadataUserBank = { data: [] } } = useGetUserBank({
    start: params.start,
    end: params.end,
    name: searchBank,
  });

  const { data: metadataSystemBank = { data: [] } } = useGetSystemBank({
    start: paramSystem.start,
    end: paramSystem.end,
    name: searchBank,
  });

  const handleChangeCurrency = (value: string) => {
    setSearchCurrency(value);
  };

  useEffect(() => {
    if (!bankAccountId || !detailBankAccount) return;
    form.setFieldsValue({
      bankId: detailBankAccount.data.bankId || "",
      accountNumber: !addNewBank
        ? detailBankAccount.data.accountNumber || ""
        : "",
      currencyCode: !addNewBank
        ? detailBankAccount.data.currencyCode || ""
        : undefined,
      abaRoutingNumber: !addNewBank
        ? detailBankAccount.data.abaRoutingNumber !== '' && detailBankAccount.data.abaRoutingNumber ? detailBankAccount.data.abaRoutingNumber : undefined
        : undefined,
      bankStateBranchNumber: !addNewBank
        ? detailBankAccount.data.bankStateBranchNumber !== '' && detailBankAccount.data.bankStateBranchNumber ? detailBankAccount.data.bankStateBranchNumber : undefined
        : undefined,
      branchNumber: !addNewBank
        ? detailBankAccount.data.branchNumber || ""
        : "",
    });
    setSearchCurrency(
      !addNewBank ? detailBankAccount.data.currencyCode || "" : ""
    );
    setBankSelected({ id: detailBankAccount.data.bankId || "" });
  }, [bankAccountId, detailBankAccount, addNewBank]);

  // useEffect(() => {
  //   const fields = addNewBank ? requiredFieldsAddNew : requiredFields;
  //   const values = form.getFieldsValue(fields);
  //   const allFilled = fields.every((field) => !!values[field]);
  //   setIsAllFieldsFilled(allFilled);
  // }, [
  //   addNewBank,
  //   bankId,
  //   accountNumber,
  //   currencyCode,
  //   abaRoutingNumber,
  //   bankStateBranchNumber,
  //   branchNumber,
  //   bankName,
  //   bankSwift,
  //   bankAddress,
  //   bankCountry,
  // ]);

  useEffect(() => {
    if (!bankAccountId || !detailBankAccount) return;
    const allBanks = [
      ...(metadataUserBank?.data || []),
      ...(metadataSystemBank?.data || []),
    ];

    const found = allBanks.some(
      (item: any) => item.id === detailBankAccount.data.bankId
    );

    if (!found) {
      setOption({
        role: detailBankAccount.data.bank.user.role,
        value: detailBankAccount.data.bankId,
        label: detailBankAccount.data.bank.name,
      });
    } else {
      setOption(null);
    }
  }, [bankAccountId, detailBankAccount, metadataUserBank, metadataSystemBank]);

  return (
    <Form
      form={form}
      onFinish={onSubmitBankAccount}
      onValuesChange={clearFieldErrorMessageOnChange(form)}
    >
      <div className="form-edit-wallet-content">
        <div className="bank-detail">
          <div className="bank-detail-header">
            <Typography.Text style={{ lineHeight: "32px" }} className="title">
              Bank Details
            </Typography.Text>
            {addNewBank ? (
              <ButtonOutlinedCustom
                text={"Cancel"}
                size="small"
                width={79}
                onClick={() => setAddNewBank(false)}
              />
            ) : null}
          </div>
          {addNewBank ? (
            <FormBankAddNew metadataCountries={metadataCountries} />
          ) : (
            <div
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  gap: 16,
                }}
              >
                <Form.Item
                  label="Bank"
                  name="bankId"
                  rules={[
                    { required: true, message: "This field is required" },
                  ]}
                  validateTrigger="onBlur"
                  className="select-bank-detail"
                >
                  <Select
                    allowClear
                    clearIcon={<ClearIcon style={{ height: 12, width: 12 }} />}
                    className="beneficiary-bank-account"
                    placeholder="Choose a bank"
                    suffixIcon={bankSelected ? null : <ArrowIcon />}
                    popupClassName="custom-select-bank"
                    showSearch
                    onChange={(id) => {
                      const selected = [
                        ...metadataSystemBank.data,
                        ...metadataUserBank.data,
                      ].find((item: any) => item.id === id);
                      setBankSelected(selected);
                    }}
                    onSearch={(value: any) => {
                      setSearchBank(value);
                      setParams({ start: 0, end: 10 });
                      setParamSystem({ start: 0, end: 10 });
                    }}
                    filterOption={() => true}
                  >
                    <OptGroup label="User Bank">
                      {option && option.role === "USER" ? (
                        <Option
                          key={option.value}
                          value={option.value}
                          label={option.labe}
                        >
                          <span
                            className="ant-select-custom-value "
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {option.label}
                          </span>
                          {bankSelected?.id === option.value && (
                            <CheckSelectIcon />
                          )}
                        </Option>
                      ) : null}
                      {Array.isArray(metadataUserBank.data) &&
                        metadataUserBank.data.map((item: any) => (
                          <Option key={item.id} value={item.id}>
                            <span
                              className="ant-select-custom-value "
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {item.name}
                            </span>
                            {bankSelected?.id === item.id && (
                              <CheckSelectIcon />
                            )}
                          </Option>
                        ))}
                      {metadataUserBank.data.length === params.end && (
                        <Option key="load-more" disabled>
                          <span
                            style={{
                              fontSize: isTablet ? 12 : 14,
                              color: "rgba(29, 171, 241, 1)",
                              fontWeight: 600,
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setParams((prev) => ({
                                ...prev,
                                end: prev.end + 10,
                              }));
                            }}
                          >
                            Load more <img src={Arrowdown} />
                          </span>
                        </Option>
                      )}
                    </OptGroup>
                    <div className="hr-bank-selected" />
                    <OptGroup label="System Banks">
                      {option && option.role !== "USER" ? (
                        <Option
                          key={option.value}
                          value={option.value}
                          label={option.labe}
                        >
                          <span
                            className="ant-select-custom-value"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {option.label}
                          </span>
                          {bankSelected?.id === option.value && (
                            <CheckSelectIcon />
                          )}
                        </Option>
                      ) : null}
                      {Array.isArray(metadataSystemBank.data) &&
                        metadataSystemBank.data.map((item: any) => (
                          <Option key={item.id} value={item.id}>
                            <span
                              className="ant-select-custom-value "
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {item.name}
                            </span>
                            {bankSelected?.id === item.id && (
                              <CheckSelectIcon />
                            )}
                          </Option>
                        ))}
                      {metadataSystemBank.data.length === paramSystem.end && (
                        <Option key="load-more" disabled>
                          <span
                            style={{
                              fontSize: isTablet ? 12 : 14,
                              color: "rgba(29, 171, 241, 1)",
                              fontWeight: 600,
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setParamSystem((prev) => ({
                                ...prev,
                                end: prev.end + 10,
                              }));
                            }}
                          >
                            Load more <img src={Arrowdown} />
                          </span>
                        </Option>
                      )}
                    </OptGroup>
                  </Select>
                </Form.Item>
                <div
                  className="button-add-new-bank"
                  onClick={() => setAddNewBank(true)}
                >
                  <PlusGradientIcon />
                </div>
              </div>
              {actionBankAccount === "EDIT" ||
                (actionBankAccount === "ADD" && bankSelected) ? (
                <>
                  <Typography.Text
                    style={{
                      color: "#ffffff",
                      fontSize: isTablet ? 12 : 14,
                      fontWeight: 400,
                    }}
                  >{`Name: ${bankSelected?.name ||
                    detailBankAccount?.data.bank.name ||
                    ""
                    }`}</Typography.Text>
                  <Typography.Text
                    style={{
                      color: "#ffffff",
                      fontSize: isTablet ? 12 : 14,
                      fontWeight: 400,
                    }}
                  >{`Swift: ${bankSelected?.swift ||
                    detailBankAccount?.data.bank.swift ||
                    ""
                    }`}</Typography.Text>
                  <Typography.Text
                    style={{
                      color: "#ffffff",
                      fontSize: isTablet ? 12 : 14,
                      fontWeight: 400,
                    }}
                  >{`Address: ${bankSelected?.legalAddress ||
                    detailBankAccount?.data.bank.legalAddress ||
                    ""
                    }`}</Typography.Text>
                </>
              ) : null}
            </div>
          )}
        </div>
        <div className="account-detail">
          <Typography.Text className="title">Account Details</Typography.Text>
          <Form.Item
            label="Account No or IBAN"
            name="accountNumber"
            validateTrigger="onBlur"
            rules={accountNumberRules}
          >
            <Input placeholder="Enter account number or IBAN" />
          </Form.Item>
          <Form.Item
            label="Currency"
            name="currencyCode"
            validateTrigger="onBlur"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Select
              placeholder="Select the account currency"
              suffixIcon={<ArrowIcon />}
              onChange={handleChangeCurrency}
              optionLabelProp="label"
            >
              {metadataCurrency.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      gap: 2,
                    }}
                  >
                    <span
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        flex: 1,
                      }}
                    >
                      {item.label}
                    </span>
                    {searchCurrency === item.value && (
                      <CheckSelectIcon style={{ flexShrink: 0 }} />
                    )}
                  </span>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="ABA Routing Number"
            name="abaRoutingNumber"
            validateTrigger="onBlur"
            rules={[
              {
                max: 25,
                message: "Maximum 25 characters",
                validateTrigger: "onBlur",
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  const trimmed = value.trim();
                  if (trimmed.length < 4) {
                    return Promise.reject(new Error("Minimum 4 characters"));
                  }

                  return Promise.resolve();
                },
              },
              onlyLatinCharsDigitsRule,
            ]}
          >
            <Input
              placeholder="Enter the ABA routing number"
              onKeyDown={(e) => {
                const target = e.currentTarget as HTMLInputElement;
                if (e.key === " " && target.selectionStart === 0) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
          <Typography.Text
            style={{
              color: '#F28A28',
              fontSize: isTablet ? 10 : 12,
              fontWeight: 400,
              lineHeight: '16px',
              marginTop: '-16px',
            }}>
            {
              'If not available, please key in 000000.'
            }
          </Typography.Text>
          <Form.Item
            label="Bank State Branch Number"
            name="bankStateBranchNumber"
            validateTrigger="onBlur"
            rules={[
              {
                max: 25,
                message: "Maximum 25 characters",
                validateTrigger: "onBlur",
              },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  const trimmed = value.trim();
                  if (trimmed.length < 4) {
                    return Promise.reject(new Error("Minimum 4 characters"));
                  }

                  return Promise.resolve();
                },
              },
              onlyLatinCharsDigitsRule,
            ]}
          >
            <Input
              placeholder="Enter the BSB number"
              onKeyDown={(e) => {
                const target = e.currentTarget as HTMLInputElement;
                if (e.key === " " && target.selectionStart === 0) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
          <Typography.Text
            style={{
              color: '#F28A28',
              fontSize: isTablet ? 10 : 12,
              fontWeight: 400,
              lineHeight: '16px',
              marginTop: '-16px',
            }}>
            {
              'If not available, please key in 000000.'
            }
          </Typography.Text>
          <Form.Item
            label="Branch Number"
            name="branchNumber"
            validateTrigger="onBlur"
            rules={branchNumberRules}
          >
            <Input placeholder="Enter the branch number" />
          </Form.Item>
          <Typography.Text
            style={{
              color: '#F28A28',
              fontSize: isTablet ? 10 : 12,
              fontWeight: 400,
              lineHeight: '16px',
              marginTop: '-16px',
            }}>
            {
              'If not available, please key in 000000.'
            }
          </Typography.Text>
        </div>
      </div>
      <div className="form-edit-wallet-footer">
        <ButtonOutlinedCustom
          text={"Cancel"}
          size={isTablet ? "medium" : "large"}
          width={"50%"}
          onClick={handleCancel}
          isLoading={isLoading}
        />
        <CustomButton
          type="submit"
          text={"Save"}
          size={isTablet ? "medium" : "large"}
          width={"50%"}
          isLoading={isLoading}
          disabled={!isAllFieldsFilled}
        />
      </div>
    </Form>
  );
};

export default FormBank;
